"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ReduxFalcorFalcorProvider: true,
  reduxFalcor: true
};
exports.reduxFalcor = exports.ReduxFalcorFalcorProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _falcorCache = require("./falcorCache");

Object.keys(_falcorCache).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _falcorCache[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _falcorCache[key];
    }
  });
});

var _lodash = _interopRequireDefault(require("lodash.debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FalcorContext = /*#__PURE__*/_react["default"].createContext();

var FalcorProviderBase = /*#__PURE__*/function (_React$Component) {
  _inherits(FalcorProviderBase, _React$Component);

  var _super = _createSuper(FalcorProviderBase);

  function FalcorProviderBase() {
    var _this;

    _classCallCheck(this, FalcorProviderBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.debounced = (0, _lodash["default"])(_this.updateCache, 250);
    return _this;
  }

  _createClass(FalcorProviderBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.falcor.onChange(this, this.debounced);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.falcor.remove(this);
    }
  }, {
    key: "updateCache",
    value: function updateCache() {
      this.props.updateCache(this.props.falcor.getCache());
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(FalcorContext.Provider, {
        value: this.props.falcor
      }, this.props.children);
    }
  }]);

  return FalcorProviderBase;
}(_react["default"].Component);

var ReduxFalcorFalcorProvider = (0, _reactRedux.connect)(null, {
  updateCache: _falcorCache.updateCache
})(FalcorProviderBase);
exports.ReduxFalcorFalcorProvider = ReduxFalcorFalcorProvider;

var reduxFalcor = function reduxFalcor(Component) {
  var Wrapper = /*#__PURE__*/function (_React$Component2) {
    _inherits(Wrapper, _React$Component2);

    var _super2 = _createSuper(Wrapper);

    function Wrapper() {
      var _this2;

      _classCallCheck(this, Wrapper);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _super2.call.apply(_super2, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this2), "WrappedComponent", /*#__PURE__*/_react["default"].createRef());

      return _this2;
    }

    _createClass(Wrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.fetchFalcorDeps();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(oldProps) {
        if (oldProps.falcorCache !== this.props.falcorCache) {
          this.fetchFalcorDeps();
        }
      }
    }, {
      key: "fetchFalcorDeps",
      value: function fetchFalcorDeps() {
        var current = this.WrappedComponent.current;
        if (!current) return;

        if (typeof current.fetchFalcorDeps === "function") {
          current.fetchFalcorDeps();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        return /*#__PURE__*/_react["default"].createElement(FalcorContext.Consumer, null, function (falcor) {
          return /*#__PURE__*/_react["default"].createElement(Component, _extends({
            ref: _this3.WrappedComponent
          }, _this3.props, {
            falcor: falcor
          }));
        });
      }
    }]);

    return Wrapper;
  }(_react["default"].Component);

  var mapStateToProps = function mapStateToProps(state) {
    return {
      falcorCache: state.falcorCache
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps, null)(Wrapper);
};

exports.reduxFalcor = reduxFalcor;